var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('div',{staticClass:"column",attrs:{"id":_vm.uniqueId}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }